import React, { useEffect, useState } from "react";
import LazyLoad from "react-lazyload";
import Header from "../Component/Header";
import Footer from "../Component/Footer";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { getSubGallery } from "../Service/Api";

const SubInternationalTours = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const id = new URLSearchParams(location.search).get("id");
  const [data, setData] = useState("");

  useEffect(() => {
    const getData = async () => {
      try {
        const subgalleryData = await getSubGallery(id);
        setData(subgalleryData);
      } catch (error) {
        console.log(error);
      }
    };

    if (id) {
      getData();
    }
  }, [id]);

  return (
    <>
      <Header />
      <div className="inner_slider">
        <LazyLoad>
          <img
            src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/inner_slider.jpg"
            className="img-fluid inner_slider_img"
            alt="St. Xaviers Bathinda"
          />
        </LazyLoad>
        <div className="row bread_cumb">
          <h2>International Tours</h2>
          <div className="theme-heading">
            <span className="colorW marB10">
              <i className="bi bi-building"></i>
            </span>
          </div>
          <h5>
            <Link to="/">
              Home <i className="bi bi-arrow-right"></i>{" "}
            </Link>
            <span>
              Bulletin <i className="bi bi-arrow-right"></i> Gallery{" "}
              <i className="bi bi-arrow-right"></i> International Tours
            </span>
          </h5>
        </div>
      </div>
      <div className="innerpage">
        <div className="inner_cont">
          <div className="row tabs-dynamic">
            <div className="col-md-6 col-xl-3">
              <div className="count-val">
                <p>
                  <a
                    href=""
                    onClick={(e) => {
                      e.preventDefault();
                      navigate("/InternationalTours");
                    }}>
                    <span id="lblcount">
                      <i className="bi bi-arrow-left"></i>
                    </span>{" "}
                    Go Back
                  </a>
                </p>
              </div>
            </div>
            <div className="col-md-6 col-xl-3">
              <div className="month-selection">
                <p>
                  <span>Event Date:</span>{" "}
                  {data?.date ? new Date(data.date).toLocaleDateString("en-GB") : "-"}
                </p>
              </div>
            </div>
            <div className="col-md-6 col-xl-3">
              <div className="month-selection">
                <p>
                  <span>Last Update:</span>{" "}
                  {data?.date ? new Date(data.date).toLocaleDateString("en-GB") : "-"}
                </p>
              </div>
            </div>
            <div className="col-md-6 col-xl-3">
              <div className="searchBox">
                <p>
                  <span>No. Of Photos:</span> {data?.attachments?.length || 0}
                </p>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <h4 className="gallery-title">{data?.title}</h4>
              <p>{data?.description}</p>
            </div>
            {data !== "" &&
              data?.attachments?.map((img, index) => (
                <div
                  key={index}
                  className="col-sm-6 col-md-6 col-lg-4 col-xl-3 col-xxl-2 galleryCount sub-gallerycount">
                  <div className="gallery-blk">
                    <LazyLoad>
                      <a
                        data-magnify="gallery"
                        data-src=""
                        data-group="a"
                        href={`https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/${img}`}>
                        <img
                          src={`https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/${img}`}
                          className="img-fluid"
                          alt=""
                        />
                      </a>
                    </LazyLoad>
                  </div>
                </div>
              ))}
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default SubInternationalTours;
